import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  NumberField,
  ChipField,
} from "react-admin";

import GlobalPagination from "../common/GlobalPagination";
import ResourceTypesField from "./ResourceTypesField";
import serviceTemplateFilters from "./serviceTemplateFilters";

const ServiceTemplateList = () => (
  <List
    sort={{ field: "name", order: "ASC" }}
    filters={serviceTemplateFilters}
    perPage={GlobalPagination.perPage}
    pagination={GlobalPagination.pagination}
  >
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <NumberField
        source="monthlyCost"
        options={{ style: "currency", currency: "EUR" }}
      />

      <ResourceTypesField source="resources" sortable={false} />

      <ChipField source="serviceBookingsCount" />

      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);
export default ServiceTemplateList;
